

export function checkUserAuthorised(allowedRoles , userRoles){

    if(allowedRoles && userRoles && !userRoles.includes(allowedRoles)){
        return false
    }
    return true

}